export class Speedometer {

	constructor( options = {} ) {

		this.maxSpeed = options.maxSpeed || 1;
		this.maxDisplaySpeed = options.maxDisplaySpeed || 220;
		this.displayRatio = 0;
		this.displaySpeed = 0;

		this._ensureStyles();

		const el = document.createElement( 'div' );
		el.id = 'speedometer-hud';

		const title = document.createElement( 'div' );
		title.className = 'title';
		title.textContent = 'Turbo Speed';

		const dial = document.createElement( 'div' );
		dial.className = 'dial';

		const sweep = document.createElement( 'div' );
		sweep.className = 'sweep';
		dial.appendChild( sweep );

		const tickLabels = [ 0, 40, 80, 120, 160, 200, 220 ];
		for ( let i = 0; i < tickLabels.length; i ++ ) {

			const ratio = i / ( tickLabels.length - 1 );
			const angle = - 120 + ratio * 240;
			const tick = document.createElement( 'div' );
			tick.className = 'tick';
			tick.style.transform = `translateX(-50%) rotate(${ angle }deg)`;
			dial.appendChild( tick );

			const label = document.createElement( 'div' );
			label.className = 'tick-label';
			label.textContent = String( tickLabels[ i ] );
			label.style.transform = `translateX(-50%) rotate(${ angle }deg) translateY(-78px) rotate(${ - angle }deg)`;
			dial.appendChild( label );

		}

		const needle = document.createElement( 'div' );
		needle.className = 'needle';
		dial.appendChild( needle );

		const hub = document.createElement( 'div' );
		hub.className = 'hub';
		dial.appendChild( hub );

		const readout = document.createElement( 'div' );
		readout.className = 'readout';
		readout.innerHTML = '<span class="value">000</span><span class="unit">KM/H</span>';

		const status = document.createElement( 'div' );
		status.className = 'status';
		status.innerHTML = '<span class="label">Cruise</span><span class="glow"></span>';

		el.appendChild( title );
		el.appendChild( dial );
		el.appendChild( readout );
		el.appendChild( status );
		document.body.appendChild( el );

		this.el = el;
		this.needle = needle;
		this.readoutValue = readout.querySelector( '.value' );
		this.statusLabel = status.querySelector( '.label' );

	}

	_ensureStyles() {

		if ( document.getElementById( 'speedometer-hud-css' ) ) return;

		const style = document.createElement( 'style' );
		style.id = 'speedometer-hud-css';
		style.textContent = `
			#speedometer-hud {
				--speedo-cyan: #5ffcff;
				--speedo-pink: #ff4fd8;
				--speedo-amber: #ffb347;
				position: absolute;
				top: 12px;
				left: 168px;
				width: 158px;
				padding: 8px 8px 7px;
				border: 1px solid rgba(95, 252, 255, 0.4);
				border-radius: 16px;
				background:
					linear-gradient(180deg, rgba(8, 19, 35, 0.78), rgba(8, 7, 23, 0.9)),
					repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.035) 0 1px, transparent 1px 14px);
				box-shadow:
					0 0 0 1px rgba(255, 79, 216, 0.18) inset,
					0 0 24px rgba(0, 221, 255, 0.22),
					0 0 44px rgba(255, 79, 216, 0.12);
				backdrop-filter: blur(10px);
				-webkit-backdrop-filter: blur(10px);
				color: #ebfdff;
				pointer-events: none;
				user-select: none;
				z-index: 11;
				overflow: hidden;
			}
			#speedometer-hud::before {
				content: '';
				position: absolute;
				inset: 0;
				background:
					linear-gradient(180deg, rgba(95, 252, 255, 0.08), transparent 30%),
					repeating-linear-gradient(180deg, rgba(255, 255, 255, 0.025) 0 2px, transparent 2px 6px);
				mix-blend-mode: screen;
				pointer-events: none;
			}
			#speedometer-hud .title {
				position: relative;
				z-index: 1;
				margin-bottom: 5px;
				font: 700 8px 'Rajdhani', 'Segoe UI', sans-serif;
				letter-spacing: 0.36em;
				text-transform: uppercase;
				color: var(--speedo-cyan);
				text-shadow: 0 0 10px rgba(95, 252, 255, 0.75);
			}
			#speedometer-hud .dial {
				position: relative;
				width: 122px;
				height: 122px;
				margin: 0 auto;
				border-radius: 50%;
				background:
					radial-gradient(circle at 50% 54%, rgba(8, 9, 23, 0.4) 0 18px, rgba(5, 9, 22, 0.95) 18px 62px, rgba(14, 36, 56, 0.95) 63px 100px, rgba(255, 79, 216, 0.12) 101px, rgba(95, 252, 255, 0.4) 104px, rgba(4, 10, 20, 0.95) 108px);
				box-shadow:
					inset 0 0 32px rgba(0, 0, 0, 0.6),
					0 0 18px rgba(95, 252, 255, 0.18);
			}
			#speedometer-hud .dial::before {
				content: '';
				position: absolute;
				inset: 10px;
				border-radius: 50%;
				border: 1px solid rgba(95, 252, 255, 0.15);
			}
			#speedometer-hud .dial::after {
				content: '';
				position: absolute;
				left: 50%;
				top: 50%;
				width: 78px;
				height: 78px;
				transform: translate(-50%, -50%);
				border-radius: 50%;
				background: radial-gradient(circle, rgba(255, 79, 216, 0.08), transparent 65%);
			}
			#speedometer-hud .sweep {
				position: absolute;
				inset: 6px;
				border-radius: 50%;
				background: conic-gradient(from 240deg, rgba(0, 0, 0, 0) 0deg, rgba(0, 0, 0, 0) 38deg, rgba(95, 252, 255, 0.24) 140deg, rgba(255, 79, 216, 0.32) 214deg, rgba(255, 179, 71, 0.88) 240deg, rgba(0, 0, 0, 0) 240deg);
				mask: radial-gradient(circle at center, transparent 0 35px, #000 37px);
				-webkit-mask: radial-gradient(circle at center, transparent 0 35px, #000 37px);
				opacity: 0.88;
			}
			#speedometer-hud .tick,
			#speedometer-hud .tick-label,
			#speedometer-hud .needle,
			#speedometer-hud .hub {
				position: absolute;
				left: 50%;
				top: 50%;
				transform-origin: center bottom;
			}
			#speedometer-hud .tick {
				width: 2px;
				width: 1px;
				height: 9px;
				margin-top: -54px;
				background: linear-gradient(180deg, rgba(255, 179, 71, 0.95), rgba(95, 252, 255, 0.3));
				box-shadow: 0 0 8px rgba(255, 179, 71, 0.55);
			}
			#speedometer-hud .tick-label {
				margin-top: 2px;
				font: 700 7px 'Rajdhani', 'Segoe UI', sans-serif;
				letter-spacing: 0.08em;
				color: rgba(234, 255, 255, 0.82);
				text-shadow: 0 0 6px rgba(95, 252, 255, 0.35);
			}
			#speedometer-hud .needle {
				width: 6px;
				width: 5px;
				height: 54px;
				margin-left: -2.5px;
				margin-top: -54px;
				border-radius: 999px;
				background: linear-gradient(180deg, #fff7db 0%, var(--speedo-amber) 34%, var(--speedo-pink) 100%);
				box-shadow:
					0 0 12px rgba(255, 179, 71, 0.9),
					0 0 24px rgba(255, 79, 216, 0.45);
				transition: transform 70ms linear;
			}
			#speedometer-hud .needle::after {
				content: '';
				position: absolute;
				left: 50%;
				bottom: -10px;
				width: 12px;
				height: 12px;
				margin-left: -6px;
				border-radius: 50%;
				background: radial-gradient(circle, #fff9ee 0 2px, var(--speedo-pink) 3px, #22071e 62%);
				box-shadow: 0 0 12px rgba(255, 79, 216, 0.7);
			}
			#speedometer-hud .hub {
				width: 14px;
				height: 14px;
				margin-left: -7px;
				margin-top: -7px;
				border-radius: 50%;
				background: radial-gradient(circle, #fff 0 2px, var(--speedo-cyan) 3px, #12061a 58%);
				box-shadow: 0 0 14px rgba(95, 252, 255, 0.55);
			}
			#speedometer-hud .readout {
				position: relative;
				z-index: 1;
				display: flex;
				align-items: baseline;
				justify-content: center;
				gap: 8px;
				margin-top: -10px;
				font-family: 'Courier New', ui-monospace, monospace;
			}
			#speedometer-hud .value {
				font-size: 24px;
				font-weight: 700;
				letter-spacing: 0.08em;
				color: #fff8d9;
				text-shadow:
					0 0 10px rgba(255, 179, 71, 0.9),
					0 0 18px rgba(255, 79, 216, 0.45);
			}
			#speedometer-hud .unit {
				font-size: 8px;
				font-weight: 700;
				letter-spacing: 0.3em;
				text-transform: uppercase;
				color: var(--speedo-cyan);
				text-shadow: 0 0 10px rgba(95, 252, 255, 0.75);
			}
			#speedometer-hud .status {
				position: relative;
				z-index: 1;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 8px;
				margin-top: 2px;
				font: 700 8px 'Rajdhani', 'Segoe UI', sans-serif;
				letter-spacing: 0.28em;
				text-transform: uppercase;
				color: rgba(239, 251, 255, 0.78);
			}
			#speedometer-hud .glow {
				width: 20px;
				height: 5px;
				border-radius: 999px;
				background: rgba(95, 252, 255, 0.3);
				box-shadow: 0 0 10px rgba(95, 252, 255, 0.35);
			}
			#speedometer-hud.boost .status {
				color: #fff2c7;
			}
			#speedometer-hud.boost .glow {
				background: linear-gradient(90deg, var(--speedo-pink), var(--speedo-amber));
				box-shadow: 0 0 12px rgba(255, 79, 216, 0.5), 0 0 18px rgba(255, 179, 71, 0.75);
			}
			#speedometer-hud.boost .value {
				color: #fffbe9;
			}
			@media (max-width: 820px) {
				#speedometer-hud {
					top: 118px;
					left: 10px;
					width: 144px;
					padding: 8px 8px 7px;
				}
				#speedometer-hud .dial {
					width: 112px;
					height: 112px;
				}
				#speedometer-hud .tick {
					height: 8px;
					margin-top: -49px;
				}
				#speedometer-hud .tick-label {
					font-size: 7px;
					transform-origin: center center;
				}
				#speedometer-hud .needle {
					height: 48px;
					margin-top: -48px;
				}
				#speedometer-hud .readout {
					margin-top: -8px;
				}
				#speedometer-hud .value {
					font-size: 22px;
				}
			}
		`;
		document.head.appendChild( style );

	}

	update( vehicle ) {

		if ( ! vehicle ) return;

		const targetRatio = Math.max( 0, Math.min( 1, Math.abs( vehicle.linearSpeed ) / this.maxSpeed ) );
		this.displayRatio += ( targetRatio - this.displayRatio ) * 0.18;

		const targetDisplaySpeed = this.displayRatio * this.maxDisplaySpeed;
		this.displaySpeed += ( targetDisplaySpeed - this.displaySpeed ) * 0.25;

		const angle = - 120 + this.displayRatio * 240;
		this.needle.style.transform = `translateX(-50%) rotate(${ angle }deg)`;
		this.readoutValue.textContent = String( Math.round( this.displaySpeed ) ).padStart( 3, '0' );

		if ( vehicle.nitroActive ) {

			this.el.classList.add( 'boost' );
			this.statusLabel.textContent = 'Boost';

		} else if ( targetRatio > 0.82 ) {

			this.el.classList.remove( 'boost' );
			this.statusLabel.textContent = 'Redline';

		} else if ( targetRatio > 0.3 ) {

			this.el.classList.remove( 'boost' );
			this.statusLabel.textContent = 'Cruise';

		} else {

			this.el.classList.remove( 'boost' );
			this.statusLabel.textContent = 'Idle';

		}

	}

}
